class CollectionBannerCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    // Bind resize function
    this.handleResize = this.handleResize.bind(this)

    // Run resize check on load
    this.handleResize()

    // Setup resize event listener
    this.setupResizeListener()
  }

  disconnectedCallback () {
    super.disconnectedCallback()
    this.removeResizeListener()
  }

  setupResizeListener () {
    this.resizeListener = this.handleResize.bind(this)
    window.addEventListener('resize', this.resizeListener)
  }

  removeResizeListener () {
    window.removeEventListener('resize', this.resizeListener)
  }

  handleResize () {
    if (window.innerWidth >= 1021) {
      this.destroyCarousel()
    } else {
      this.CollectionBannerCarouselSetup()
    }
  }

  async CollectionBannerCarouselSetup () {
    const collectionCarouselContainer = this.els['collection-slider']?.element

    // Ensure it's only set up if it's not already initialized
    if (collectionCarouselContainer && window.innerWidth <= 1021 && !this.carouselInstance) {
      this.setupCarousel(collectionCarouselContainer)
      this.els.slides.element.setAttribute('data-initialised', 'true')
    }
  }

  destroyCarousel () {
    if (this.carouselInstance) {
      this.carouselInstance.destroy()
      this.carouselInstance = null
      this.els.slides.element.setAttribute('data-initialised', 'false')
    }
  }

  setupCarousel (slidesEl) {
    this.carouselInstance = new window.KeenSlider(
      slidesEl,
      {
        selector: this.els.slide.selector,
        loop: false, // Ensure it doesn't loop, so we can detect start and end
        mode: 'snap',
        rubberband: false,
        slides: {
          spacing: 10,
          perView: 'auto',
        },
      },
    )

    this.previousButton = this.els.previous.element
    this.nextButton = this.els.next.element

    // Add event listeners for arrows
    this.previousButton.addEventListener('click', () => this.carouselInstance.prev())
    this.nextButton.addEventListener('click', () => this.carouselInstance.next())

    // Listen for slide changes and update arrow visibility
    this.carouselInstance.on('slideChanged', () => this.updateArrowVisibility())

    // Ensure correct arrow visibility on initialization
    this.updateArrowVisibility()
  }

  updateArrowVisibility () {
    if (!this.carouselInstance) return

    const currentSlide = this.carouselInstance.track.details.rel
    const lastSlide = this.carouselInstance.track.details.maxIdx

    // Hide previous button on first slide
    if (currentSlide === 0) {
      this.previousButton.style.display = 'none'
    } else {
      this.previousButton.style.display = 'flex'
    }

    // Hide next button on last slide
    if (currentSlide === lastSlide) {
      this.nextButton.style.display = 'none'
    } else {
      this.nextButton.style.display = 'flex'
    }
  }
}

if (!customElements.get('collection-banner-carousel')) {
  customElements.define('collection-banner-carousel', CollectionBannerCarousel)
}
